import { Flex, Icon, IconButton, InputGroup, InputLeftElement, Text, Box, Divider } from '@chakra-ui/react'
import { Filter, List, Map, Tennis } from '../icons/icons'
import { useUserWrapperContext } from '../wrappers/UserWrapper'
import { useEffect, useRef, useState } from 'react'
import { EVENT_TYPES_OBJECT_FILTERED, getEventLabel } from '../../types/EventTypes'
import LocationSearch from './LocationSearch'
import useMobile from '../../hooks/useMobile'

const PlaySearchFilter = (props: {
  hasMapToggle?: boolean
  collapsed?: boolean
  onLocationSearch?: (location: { lat: number; lng: number }) => void // Function to update map center
}) => {
  const {
    filterToggled,
    setFilterToggled,
    mapToggled,
    setMapToggled,
    searchPlay,
    setSearchPlay,
    location,
    setLocation,
    filterActive,
  } = useUserWrapperContext()

  const [customSelectOpen, setCustomSelectOpen] = useState(false)

  const componentRef = useRef<HTMLDivElement>(null)
  const triggerRef = useRef<HTMLDivElement>(null)
  const isMobile = useMobile(600)

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        componentRef.current &&
        !componentRef.current?.contains(event.target) &&
        triggerRef.current &&
        !triggerRef.current?.contains(event.target)
      ) {
        setCustomSelectOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <>
      <Flex
        gap="10px"
        h={props.collapsed ? '0' : '40px'}
        mb={props.collapsed ? '0' : '10px'}
        mt={isMobile ? '10px' : '0px'}
        transition="0.3s ease-out"
        position="relative"
      >
        <InputGroup
          bgColor="#F5F7F9"
          borderRadius="10px"
          cursor="pointer"
          onClick={() => {
            setCustomSelectOpen(!customSelectOpen)
          }}
          ref={triggerRef}
          _hover={{
            backgroundColor: '#eceef2',
          }}
        >
          <InputLeftElement>
            <Icon w="22px" h="22px">
              <Tennis color="black" />
            </Icon>
          </InputLeftElement>
          <Box p="9px 0px 0px 40px" w="100%" color={location ? 'black' : 'black'} fontSize="lg">
            {location ? getEventLabel(location) : 'Event Type'}
          </Box>
          {/* <Select
                    icon={<></>}

                    onChange={e => setLocation(e.target.value)}
                    value={location}
                    variant='filled'
                    paddingLeft="24px"
                    placeholder="Event Type"
                    fontSize="lg"
                    w="100%"
                    color=""
                    border="0"
                    backgroundColor="#F5F7F9"
                    _hover={{
                        backgroundColor: "#eceef2"
                    }}
                    bg='#F5F7F9'
                    textDecoration="none"
                >
                    {EVENT_TYPES_OBJECT_FILTERED.map((object : any, i : number) => {
                        return <option key={i} value={object.type}>{object.display_name}</option>
                    })}
                </Select> */}
        </InputGroup>
        {customSelectOpen && (
          <Box
            top="50px"
            w="calc(100% - 50px)"
            bgColor="#F5F7F9"
            borderRadius="10px"
            zIndex={1000}
            position="absolute"
            boxShadow="0px 12.914606094360352px 86.71235656738281px 0px #2B2C2D14"
            borderWidth="1px"
            pl="8px"
            ref={componentRef}
          >
            <>
              <Text
                p="8px"
                color="#171C22"
                cursor="pointer"
                fontWeight="500"
                onClick={() => {
                  setLocation('')
                  setCustomSelectOpen(false)
                }}
              >
                All
              </Text>
              <Divider />
            </>
            {EVENT_TYPES_OBJECT_FILTERED.map((object: any, i: number) => {
              return (
                <>
                  <Text
                    p="8px"
                    color="#171C22"
                    cursor="pointer"
                    fontWeight="500"
                    onClick={() => {
                      setLocation(object.type)
                      setCustomSelectOpen(false)
                    }}
                    key={i}
                  >
                    {object.display_name}
                  </Text>
                  <Divider />
                </>
              )
            })}
          </Box>
        )}

        <IconButton
          onClick={() => {
            setFilterToggled(!filterToggled)
          }}
          aria-label="filters"
          variant="light"
          borderRadius="10px"
          icon={
            <Icon width="25px" height="26px" viewBox="0 0 27 28" mb="4px" ml="3px">
              <Filter color={!filterActive ? 'black' : '#06C270'} fill="black" />
            </Icon>
          }
        />
      </Flex>
      <Flex gap="10px" mb={props.collapsed ? '0px' : '10px'} visibility={!customSelectOpen ? 'visible' : 'hidden'}>
        <Flex direction="row" bg="#F5F7F9" border="none" borderRadius="10px" w="100%" alignItems={'center'}>
          {/* <Box px='9px'  >
                <Icon w='22px' h='22px'>
                    <LocationMarker color="black" />
                </Icon>
            </Box> */}

          <Box w="100%">
            <LocationSearch
              location={searchPlay}
              playPage={true}
              setLocation={setSearchPlay}
              setCoordinates={(coords) => props.onLocationSearch && props.onLocationSearch(coords)} // Update map center with coordinates
              placeholder="Search / Around me"
              fontSize="lg"
            />
          </Box>
        </Flex>
        {props.hasMapToggle ? (
          <IconButton
            onClick={() => {
              console.log('clicked')
              setMapToggled(!mapToggled)
              console.log(mapToggled)
            }}
            aria-label="filters"
            variant="light"
            borderRadius="10px"
            icon={
              <Icon
                width="20px"
                height={mapToggled ? '15px' : '20px'}
                viewBox={mapToggled ? '0 0 20 15' : '0 0 20 20'}
                color="#171C22"
                fill="none"
              >
                {mapToggled ? <List color="#171C22" /> : <Map />}
              </Icon>
            }
          />
        ) : (
          <></>
        )}
      </Flex>
    </>
  )
}

export default PlaySearchFilter
